<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #pageContentArea>
        <a-steps
          :current="currentStep"
          style="border-bottom: 1px solid #e0e0e0;"
          class="py-2 mb-3"
          size="small"
        >
          <a-step title="Define Fields" />
          <a-step title="Build Form" />
          <a-step title="Review" />
        </a-steps>

        <div class="col-md-12" v-if="currentStep == 0">
          <button v-if="selectedActions.includes('Edit')" class="btn btn-sm btn-warning float-right" @click="handleAdd(null)"> + Add Custom Field</button> <br/><br/>
          <a-table :columns="columns" :dataSource="dataSource" :pagination="dataSourcepagination" bordered>
              <template
                v-for="col in ['code', 'name', 'data_type']"
                :slot="col"
                slot-scope="text, record"
              >
                <div :key="col" v-if="col == 'data_type'">
                  <a-select v-if="record.editable" style="width: 100%" placeholder="Select input type" @select="e => handleChange(e, record.key, col)">
                    <a-select-option v-for="inputType in formDataTypes" :key="inputType" :value="inputType">{{inputType}}</a-select-option>
                  </a-select>
                  <template v-else>{{text}}</template
                  >
                </div>

                <div :key="col" v-else>
                  <input
                    v-if="record.editable"
                    style="margin: -5px 0"
                    :value="text"
                    @change="e => handleChange(e.target.value, record.key, col)"
                  />
                  <template v-else>{{text}}</template
                  >
                </div>
              </template>
              <template v-if="selectedActions.includes('Edit')" slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                  <span v-if="record.editable">
                    <a class="btn btn-sm btn-primary" style="color: white;" @click="() => save(record.key, null)">Save</a>
                    <a class="btn btn-sm btn-warning" style="color: white;" @click="() => cancel(record.key, null)">Cancel</a>
                  </span>
                  <span v-else>
                    <a style="color: white;" class="btn btn-sm btn-primary" @click="() => edit(record.key)">Edit</a>
                    <a-popconfirm title="This will also delete coresponding form component. Are you sure you want to delete this custom field?" @confirm="() => deleteField(record, null)">
                      <a style="color: white;" class="btn btn-sm btn-danger">Delete</a>
                    </a-popconfirm>
                  </span>
                </div>
              </template>
          </a-table>
        </div>

        <div class="col-md-12" v-if="currentStep == 1">
          <!-- v-if="selectedActions.includes('Edit')" -->
          <button v-if="viewMode == null && selectedActions.includes('Edit')" class="btn btn-sm btn-warning float-right" @click.prevent="showFormBuilder('addGroup')"> + Add Group </button>
          <button v-if="groups.length > 0 && viewMode != null && selectedActions.includes('Edit')" class="btn btn-sm btn-primary float-right" @click.prevent="viewMode = null"> Show Editor </button> <br/><br/>

          <a-drawer title="Form Builder" :width="900" placement="right" @close="formBuilderClose" :visible="formBuilderVisible">
                <div v-if="formBuilderType == 'addGroup' || formBuilderType == 'editGroup'">
                    <base-input label="Group Name">
                        <a-input type="text" v-model="group.name"/>
                    </base-input>
                    <base-input label="Group Description">
                        <a-textarea :autoSize="{ minRows: 6, maxRows: 10 }" v-model="group.description"/>
                    </base-input>
                    <base-input label="Sequence">
                        <a-input type="number" v-model="group.sequence"/>
                    </base-input>
                </div>
                <div v-if="formBuilderType == 'addComponents' || formBuilderType == 'editComponent'" >
                    <base-input label="Field Name">
                        <a-select @select="setField" style="width: 100%" placeholder="Select field" v-model="component.code" :filterOption="filterOption" showSearch>
                            <a-select-option v-for="field in modelAttributes" :key="field.field_name" :value="field.field_name">{{field.label}}</a-select-option>
                        </a-select>
                    </base-input>
                    <base-input label="Input Type">
                        <a-select style="width: 100%" placeholder="Select input type" v-model="component.type" :disabled="fieldDetailsDisabled">
                            <a-select-option v-for="inputType in formInputTypes" :key="inputType" :value="inputType">{{inputType}}</a-select-option>
                        </a-select>
                    </base-input>
                    <div v-if="component.type != null">
                        <base-input label="Required">
                           <br/>
                          <a-switch v-model="component.required" :disabled="fieldDetailsDisabled"/>
                        </base-input>
                        <base-input label="Label">
                            <a-input type="text" v-model="component.label"/>
                        </base-input>
                        <base-input label="Description">
                            <a-textarea :autoSize="{ minRows: 3, maxRows: 6 }" v-model="component.description"/>
                        </base-input>
                        <base-input label="Default Value">
                            <a-input type="text" v-model="component.defaultValue" :disabled="fieldDetailsDisabled"/>
                        </base-input>
                        <base-input v-if="group.terminalSettings != undefined && fieldDetailsDisabled == false" label="Conditions">
                            <button v-if="selectedActions.includes('Edit')" class="btn btn-sm btn-warning float-right" @click="handleAdd('conditions')"> + Add Condition</button> <br/><br/>
                            <a-table :columns="conditionColumns" :dataSource="component.conditions" bordered :key="tableConditionKey">
                                <template
                                  v-for="col in ['code', 'operator', 'value']"
                                  :slot="col"
                                  slot-scope="text, record"
                                >
                                  <div :key="col">
                                    <div v-if="col == 'code'">
                                        <a-select v-if="record.editable" style="width: 100%" placeholder="Select field" @select="e => handleChange(e, record.key, col, 'conditions')">
                                            <a-select-option v-for="terminalSetting in group.terminalSettings" :key="terminalSetting.key" :value="terminalSetting.code">{{terminalSetting.label}}</a-select-option>
                                        </a-select>
                                        <template v-else>{{text}}</template>
                                    </div>
                                    <div v-if="col == 'operator'">
                                        <a-select v-if="record.editable" style="width: 100%" placeholder="Select operation" @select="e => handleChange(e, record.key, col, 'conditions')">
                                            <a-select-option v-for="operation in operations" :key="operation" :value="operation">{{operation}}</a-select-option>
                                        </a-select>
                                        <template v-else>{{text}}</template>
                                    </div>
                                    <div v-if="col == 'value'">
                                         <input
                                          v-if="record.editable"
                                          style="margin: -5px 0"
                                          :value="text"
                                          @change="e => handleChange(e.target.value, record.key, col, 'conditions')"
                                        />
                                        <template v-else>{{text}}</template>
                                    </div>
                                  </div>
                                </template>
                                <template slot="operation" slot-scope="text, record">
                                  <div class="editable-row-operations">
                                    <span v-if="record.editable">
                                      <a class="btn btn-sm btn-primary" style="color: white;" @click="() => save(record.key, 'conditions')">Save</a>
                                    </span>
                                    <span v-else>
                                      <a style="color: white;" class="btn btn-sm btn-primary" @click="() => edit(record.key, 'conditions')">Edit</a>
                                      <a-popconfirm title="Are you sure you want to delete this condition?" @confirm="() => deleteField(record, 'conditions')">
                                        <a style="color: white;" class="btn btn-sm btn-danger">Delete</a>
                                      </a-popconfirm>
                                    </span>
                                  </div>
                                </template>
                            </a-table>
                        </base-input>
                    </div>
                    <div v-if="component.type == 'cascader'">
                        <base-input label="Endpoint">
                            <a-input type="text" v-model="component.endpoint" :disabled="fieldDetailsDisabled"/>
                        </base-input>
                    </div>
                    <div v-if="component.type == 'select' || component.type == 'multiple_select' || component.type == 'radio'">
                        <base-input label="Option Source">
                            <br/>
                            <a-radio-group v-model="component.selectStyle" @change.prevent="reviewOptions" :disabled="fieldDetailsDisabled">
                                <a-radio value="1" :key="1"> Manual</a-radio>
                                <a-radio value="2" :key="2"> Define endpoint</a-radio>
                            </a-radio-group>
                        </base-input>
                        <div v-if="component.selectStyle == 1">
                            <button v-if="selectedActions.includes('Edit')" class="btn btn-sm btn-warning float-right" @click="handleAdd('options')"> + Add Option</button> <br/><br/>
                            <a-table :columns="optionColumns" :dataSource="component.options" bordered :key="tableOptionKey">
                                <template
                                  v-for="col in ['id', 'name']"
                                  :slot="col"
                                  slot-scope="text, record"
                                >
                                  <div :key="col">
                                    <input
                                      v-if="record.editable"
                                      style="margin: -5px 0"
                                      :value="text"
                                      @change="e => handleChange(e.target.value, record.key, col, 'options')"
                                    />
                                    <template v-else>{{text}}</template
                                    >
                                  </div>
                                </template>
                                <template slot="operation" slot-scope="text, record">
                                  <div class="editable-row-operations">
                                    <span v-if="record.editable">
                                      <a class="btn btn-sm btn-primary" style="color: white;" @click="() => save(record.key, 'options')">Save</a>
                                    </span>
                                    <span v-else>
                                      <a style="color: white;" class="btn btn-sm btn-primary" @click="() => edit(record.key, 'options')">Edit</a>
                                      <a-popconfirm title="Are you sure you want to delete this option?" @confirm="() => deleteField(record, 'options')">
                                        <a style="color: white;" class="btn btn-sm btn-danger">Delete</a>
                                      </a-popconfirm>
                                    </span>
                                  </div>
                                </template>
                            </a-table>
                        </div>
                        <base-input v-if="component.selectStyle == 2" label="Endpoint">
                            <a-input type="text" v-model="component.endpoint" :disabled="fieldDetailsDisabled"/>
                        </base-input>
                    </div>
                </div>
                <!-- v-if="selectedActions.includes('Edit')"  -->
                <div v-if="(formBuilderType == 'addGroup' || formBuilderType == 'editGroup') && selectedActions.includes('Edit')" :style="stickyButton">
                    <button v-if="formBuilderType == 'addGroup'" style="margin-left: 8px" class="btn btn-sm btn-primary" @click.prevent="addGroup"> Save </button>
                    <button v-else style="margin-left: 8px" class="btn btn-sm btn-primary" @click.prevent="saveGroup(group)"> Save </button>
                    <button style="margin-left: 8px" class="btn btn-sm btn-danegr" @click.prevent="formBuilderClose"> Cancel </button>
                </div>
                <div v-else :style="stickyButton">
                    <div v-if="selectedActions.includes('Edit')">
                    <button v-if="formBuilderType == 'addComponents'" style="margin-left: 8px" class="btn btn-sm btn-primary" @click.prevent="addComponent"> Save </button>
                    <button v-else style="margin-left: 8px" class="btn btn-sm btn-primary" @click.prevent="saveComponent(component)"> Save </button>
                    <button style="margin-left: 8px" class="btn btn-sm btn-danegr" @click.prevent="formBuilderClose"> Cancel </button>
                    </div>
                </div>
          </a-drawer>

          <div v-for="group in groups" :key="group.key">
            <a-card :title="group.name" >
                <a-dropdown slot="extra" v-if="selectedActions.includes('Edit')">
                    <a class="ant-dropdown-link">
                        <span class="fa fa-ellipsis-v"></span>
                    </a>
                    <a-menu slot="overlay">
                        <a-menu-item key=1>
                            <a @click.prevent="showFormBuilder('editGroup', group)">Edit</a>
                        </a-menu-item>
                        <a-menu-item key=2>
                            <a @click.prevent="showFormBuilder('addComponents', group)">Add Components</a>
                        </a-menu-item>
                        <a-menu-item key=3>
                              <a-popconfirm title="Are you sure you want to delete this form group?" @confirm="() => deleteGroup({group: group} )">
                                <a>Delete</a>
                              </a-popconfirm>
                          </a-menu-item>
                    </a-menu>
                </a-dropdown>

                <h6 class="heading-small text-muted mb-4">Form Components</h6>
                <a-table :columns="componentColumns" :dataSource="group.terminalSettings" :key="componentsTableKey" bordered>
                  <a-dropdown v-if="selectedActions.includes('Edit')" slot="actions" slot-scope="text, record">
                      <a class="ant-dropdown-link">
                          <span class="fa fa-ellipsis-v"></span>
                      </a>
                      <a-menu slot="overlay">
                          <a-menu-item key=1>
                              <a @click.prevent="showFormBuilder('editComponent', {component: record, group: group} )">Edit</a>
                          </a-menu-item>
                          <a-menu-item key=2>
                              <a-popconfirm title="Are you sure you want to delete this component?" @confirm="() => deleteComponent({component: record, group: group} )">
                                <a>Delete</a>
                              </a-popconfirm>
                          </a-menu-item>
                      </a-menu>
                  </a-dropdown>

                </a-table>

            </a-card>
          <br/> <br/>
        </div>

        </div>

        <div class="col-md-12" v-if="currentStep == 2">
          <!-- {{ this.groups }} -->
          <dynamic-form :convertedJson="{mode: 'tabs', groups: groups}"></dynamic-form>
        </div>

        <!-- style="position: absolute; bottom: 2rem;right: 2.5rem; width: -moz-webkit-fill-available; padding: 10px;" -->
        <hr/>
        <div class="float-md-right" style="padding: 10px;">
          <div class="container mx-0 px-0">
            <div class="row">
              <div class="col-auto" v-if="currentStep >= 1 && currentStep <= 2">
                <b-button
                  class="float-md-left"
                  size="sm"
                  style="margin-left: 8px"
                  @click="currentStep--"
                >
                  Back
                </b-button>
              </div>

              <div class="col-auto" v-if="currentStep >= 0 && currentStep <= 1">
                <template>
                  <b-button size="sm" variant="success" @click="currentStep++">
                    Next
                  </b-button>
                </template>
              </div>

              <div class="col-auto" v-if="currentStep==2 && selectedActions.includes('Edit')">
                <template>
                  <b-button size="sm" variant="success" @click="saveDynamicForm">
                    Done
                  </b-button>
                </template>
              </div>


              <br/><br/>
            </div>
          </div>
        </div>

      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/FullContent.vue';
import DynamicForm from '../DynamicForm.vue';
import HTTPRequest from '../../controllers/httpRequest';
import Vue from 'vue';
import _ from 'lodash';
import { mapGetters } from 'vuex';

export default {
  components: {
    PageHeader,
    PageContent,
    DynamicForm
  },
  props: {
    gradientType: {
      type: String,
      default: 'gradient-green'
    },
    headerClass: {
      type: String,
      default: 'pb-6 pb-8 pt-5 pt-md-8'
    }
  },
  data() {
    return {
      // selectedActions: [],
      component: {},
      currentStep: 0,
      mode: 'A',
      referenceId: null,

      // Styles
      stickyButton: { position: 'absolute', left: 0, bottom: 0, width: '100%', borderTop: '1px solid #e9e9e9', padding: '10px 16px', background: '#fff', textAlign: 'right'},

      // --- START :: STEP 1 - Define Fields --- //
      dataSource: [],
      completeAttributes: [],
      formDataTypes: ["string", "integer", "double", "boolean", "datetime"] ,
      dataSourcepagination: {
        defaultCurrent: 1,
        current: 1,
        onChange: (current) => {
          this.dataSourcepagination.current = current;
        },
      },
      columns: [
          {
            title: 'Field Name',
            dataIndex: 'name',
            width: '25%',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: 'Field Code',
            dataIndex: 'code',
            width: '25%',
            scopedSlots: { customRender: 'code' },
          },
          {
            title: 'Data Type',
            dataIndex: 'data_type',
            width: '25%',
            scopedSlots: { customRender: 'data_type' },
          },
          {
            title: '',
            dataIndex: 'operation',
            width: '20%',
            scopedSlots: { customRender: 'operation' },
          }
      ],
      // --- END :: STEP 1 - Define Fields --- //

      // --- START :: STEP 2 - Form Builder --- //
      viewMode: null,
      groups: [],
      group: {name: null, description: null},
      formBuilderVisible: false,
      formBuilderType: null,
      existingConfig: [],
      modelAttributes: [],
      formInputTypes: ["text", "number", "select", "multiple_select", "boolean", "date", "time", "radio", "switch", "range", "cascader"] ,
      fieldDetailsDisabled: false,
      componentsTableKey: 0,
      tableOptionKey: 0,
      tableConditionKey: 0,
      operations: ["NOT NULL", "IS NULL", "=", ">=", "<=", ">", "<", "IN"],
      componentColumns: [
          {
            title: 'Label',
            dataIndex: 'label',
            width: '40%',
            scopedSlots: { customRender: 'label' },
          },
          {
            title: 'Field Name',
            dataIndex: 'code',
            width: '40%',
            scopedSlots: { customRender: 'code' },
          },
          {
            title: 'Type',
            dataIndex: 'type',
            width: '40%',
            scopedSlots: { customRender: 'type' },
          },
          {
            title: '',
            dataIndex: 'actions',
            scopedSlots: { customRender: 'actions' },
          },
      ],
      conditionColumns: [
          {
            title: 'Code',
            dataIndex: 'code',
            width: '25%',
            scopedSlots: { customRender: 'code' },
          },
          {
            title: 'Operation',
            dataIndex: 'operator',
            width: '25%',
            scopedSlots: { customRender: 'operator' },
          },
          {
            title: 'Value',
            dataIndex: 'value',
            width: '25%',
            scopedSlots: { customRender: 'value' },
          },
          {
            title: '',
            dataIndex: 'operation',
            width: '25%',
            scopedSlots: { customRender: 'operation' },
          },
      ],
      optionColumns: [
          {
            title: 'Option Key/ID',
            dataIndex: 'id',
            width: '40%',
            scopedSlots: { customRender: 'id' },
          },
          {
            title: 'Option Label',
            dataIndex: 'name',
            width: '40%',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '',
            dataIndex: 'operation',
            width: '20%',
            scopedSlots: { customRender: 'operation' },
          },
      ],
      // --- END :: STEP 2 - Form Builder --- //

    };
  },
  computed:{
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  methods: {
    // --- START :: STEP 1 - Define Fields --- //
    handleAdd(type=null) {
      if(type == null){
        const { dataSource } = this;
        if(dataSource.length > 0){
          var ds = dataSource.slice().sort((a, b) => parseInt(a.key) - parseInt(b.key))
          this.count = ds[ds.length - 1].key + 1
        }else {
          this.count = 0
        }
        console.log(this.count)
        const newData = { key: this.count,  code: "", name: "", editable: true};
        let newDs = [...dataSource,newData];
        this.dataSource = newDs;
        var page = Math.ceil(this.dataSource.length / 10) || 1;
        this.dataSourcepagination.current = page;
      } else if (type == 'options') {
        var options = []
        if (this.component.options != undefined){
          options = this.component.options
          if(this.component.options.length > 0){
            this.count = this.component.options[this.component.options.length - 1].key + 1
          }else {
            this.count = 0
          }
        } else {
          this.count = 0
        }
        const newData = { key: this.count,  id: "", name: "", editable: true};
        this.component.options = [...options, newData]
        this.tableOptionKey++
      } else {
        var conditions = []
        if (this.component.conditions != undefined){
          conditions = this.component.conditions
          if(this.component.conditions.length > 0){
            this.count = this.component.conditions[this.component.conditions.length - 1].key + 1
          }else {
            this.count = 0
          }
        } else {
          this.count = 0
        }

        const newData = { key: this.count,  code: "", operator: "", value: "", editable: true};
        this.component.conditions = [...conditions, newData]
        this.tableConditionKey++
      }
      //this.count++;

    },
    handleChange(value, key, column, type=null) {
        if(type == null){
            const newData = [...this.dataSource];
            const target = newData.filter(item => key === item.key)[0];
            if (target) {
              target[column] = value;
              this.dataSource = newData;
            }
        } else if (type == 'options') {
            const newData = [...this.component.options];
            const target = newData.filter(item => key === item.key)[0];
            if (target) {
              target[column] = value;
              this.component.options = newData;
            }
        } else {
            const newData = [...this.component.conditions];
            const target = newData.filter(item => key === item.key)[0];
            if (target) {
              target[column] = value;
              this.component.conditions = newData;
            }
        }
    },
    edit(key, type=null) {
      if(type == null){
        const newData = [...this.dataSource];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.editable = true;
          this.dataSource = newData;
        }
      } else if (type == 'options') {
        const newData = [...this.component.options];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.editable = true;
          this.component.options = newData;
          this.tableOptionKey++
        }
      } else {
        const newData = [...this.component.conditions];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.editable = true;
          this.component.conditions = newData;
          this.tableConditionKey++
        }
      }

    },
    save(key, type=null) {
      console.log("---Saving")
      console.log(type);
        if(type == null){
            const newData = [...this.dataSource];
            const defNewData = [...this.completeAttributes];
            const target = newData.filter(item => key === item.key)[0];
            if (target) {
                if( (target.name == null || target.name == '') ||  (target.code == null || target.code == '')){
                this.$message['error'](
                    "Cannot save. Null values."
                );
                }  else {
                const dupCode = newData.filter(item => target.name === item.name).length;
                const dupName = newData.filter(item => target.code === item.code).length;
                const defDupCode = defNewData.filter(item => target.code === item.field_name).length;
                const defDupName = defNewData.filter(item => target.name === item.label).length;
                if(dupCode > 1 || dupName > 1 || defDupCode > 0 || defDupName > 0){
                  this.$message['error'](
                      "Cannot save. Duplicate value."
                  );
                } else {
                  delete target.editable;
                  this.dataSource = newData;
                  Object.assign(
                    target
                  );
                }
              }
            }
        } else if (type == 'options') {
            const newData = [...this.component.options];
            const target = newData.filter(item => key === item.key)[0];
            if(target){
                delete target.editable;
                this.component.options = newData;
                Object.assign(
                  target
                );
                this.tableOptionKey++
            }
        } else {
            const newData = [...this.component.conditions];
            const target = newData.filter(item => key === item.key)[0];
            if(target){
                delete target.editable;
                this.component.conditions = newData;
                Object.assign(
                  target
                );
                this.tableConditionKey++
            }
        }
    },
    deleteField(record, type=null) {
        if(type == null){
            const dataSource = [...this.dataSource];
            this.dataSource = dataSource.filter(item => item.key !== record.key);
            this.refreshDataSet()
        } else if (type == 'options') {
            const dataSource = [...this.component.options];
            this.component.options = dataSource.filter(item => item.key !== record.key);
            this.tableOptionKey++
        } else {
          const dataSource = [...this.component.conditions];
          this.component.conditions = dataSource.filter(item => item.key !== record.key);
          this.tableConditionKey++
        }
    },
    cancel(key, type=null){
      if(type == null){
        const newData = [...this.dataSource];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          delete target.editable;
          this.dataSource = newData;
          Object.assign(
            target
          );
        }
      }
    },
    // --- END :: STEP 1 - Define Fields --- //

    // --- START :: STEP 2 - Form Builder --- //
    async showFormBuilder(type, parameters=null){
        this.formBuilderVisible = true
        this.formBuilderType = type
        if(type == 'editGroup' || type == 'addComponents') this.group = parameters
        if(type == 'editComponent') {
          this.group = parameters.group
          this.component = parameters.component
        }
        if(type == 'addComponents') this.component = {}
        if (type == 'addComponents' || type == 'editComponent'){
          this.refreshDataSet()
        }
    },

    async refreshDataSet(){
      const customFields = [...this.dataSource]
      var customFieldsFormatted = []
      customFields.map(x => customFieldsFormatted.push({field_name: x.code, label: x.name, data_type: x.data_type}))

      const attributes = [...customFieldsFormatted]
      const attributeCodes = []
      attributes.map(item => attributeCodes.push(item["field_name"]))

      this.existingConfig = []
      for(var i = 0; this.groups.length > i; i++ ){
        var currentGroup = this.groups[i]
        if (currentGroup.terminalSettings != undefined){
          const codes = [...currentGroup.terminalSettings]
          codes.map(x => {
            if(attributeCodes.includes(x["code"]) == false){
              currentGroup.terminalSettings = codes.filter(item => item.code != x["code"])
            }else{
              this.existingConfig.push(x["code"])
            }
          })
        }
      }

      this.modelAttributes = attributes.filter(item => !this.existingConfig.includes(item.field_name));

    },

    setField(value){
      const target = this.modelAttributes.filter(item => value === item.field_name)[0];
      this.currentField = target
      Vue.set(this.component, 'label', this.currentField.label)
      Vue.set(this.component, 'required', this.currentField.required)

      //if(this.currentField.required == true){
      //  this.fieldDetailsDisabled = true
      //} else {
      //  this.fieldDetailsDisabled = false
      //}

      switch(this.currentField.data_type) {
        case "integer":
          if(value.includes('_id')){
            Vue.set(this.component, 'type', "select")
            Vue.set(this.component, 'selectStyle', "2")
            var referenceModel = _.pluralize(value.split("_id")[0])
            Vue.set(this.component, 'endpoint', "/" + referenceModel + "/get_valid_" + referenceModel)
          }
          else
            Vue.set(this.component, 'type', "number")
          break;
        case "string":
          Vue.set(this.component, 'type', "text")
          break;
        case "boolean":
          Vue.set(this.component, 'type', "boolean")
          break;
        case "decimal":
          Vue.set(this.component, 'type', "number")
          break;
        case "datetime":
          Vue.set(this.component, 'type', "date")
          break;
      }
    },

    formBuilderClose(){
      this.formBuilderVisible = false
      this.group = {name: null, description: null}
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    reviewOptions(){
      if(this.component.selectStyle == 1){
          delete this.component.endpoint
      } else {
          delete this.component.options
          this.tableOptionKey
      }
    },

    // Groups
    addGroup(){
        var groupKey = this.groups.length + 1
        var newGroup = {key: groupKey, sequence: groupKey, name: this.group.name, description: this.group.description}
        this.groups.push(newGroup)
        this.group = {name: null, description: null}
        this.formBuilderClose()
    },
    saveGroup(){
        // var objIndex = this.groups.findIndex((obj => obj.key == group.key));
        // var updateGroup = this.groups[objIndex]
        // updateGroup = group
        this.formBuilderClose()
    },
    deleteGroup(parameters){
      this.group = parameters.group
      const dataSource = [...this.groups];
      this.groups = dataSource.filter(item => item.key !== this.group.key);
    },

    //Components
    addComponent(){
        var componentKey = 0
        if(this.group.terminalSettings == undefined){
            this.group.terminalSettings = []
            componentKey = 1
        } else {
            componentKey = this.group.terminalSettings.length + 1
        }

        var newComponent = this.component
        var valid = false

        if(newComponent["code"] != undefined || newComponent["type"] != undefined || newComponent["label"] != undefined){
          if(newComponent["type"] == 'select' || newComponent["type"] == 'multiple_select' || newComponent["type"] == 'cascader' || newComponent["type"] == 'radio'){
            if(newComponent["options"] != undefined && newComponent["options"] != [] ){
              valid = true
            }else{
              if (newComponent["endpoint"] != undefined && (newComponent["endpoint"] != null || newComponent["endpoint"] != "") ){
                valid = true
              }
            }
          } else {
            valid = true
          }
        }

        if(valid == true){
          newComponent["key"] = componentKey
          this.group.terminalSettings.push(newComponent)
          this.component = {}
          this.refreshDataSet()
          this.formBuilderClose()
          this.componentsTableKey++
        } else {
          this.$message['error'](
            "Cannot save. Please validate your inputs."
          );
        }

    },
    saveComponent(component){
      // var objIndex = this.group.terminalSettings.findIndex((obj => obj.key == component.key));
      // var updateComponent = this.group.terminalSettings[objIndex]
      var newComponent = component;
      var valid = false

      if(newComponent["code"] != undefined || newComponent["type"] != undefined || newComponent["label"] != undefined){
        if(newComponent["type"] == 'select' || newComponent["type"] == 'multiple_select' || newComponent["type"] == 'cascader' || newComponent["type"] == 'radio'){
          if(newComponent["options"] != undefined && newComponent["options"] != [] ){
            valid = true
          }else{
            if (newComponent["endpoint"] != undefined && (newComponent["endpoint"] != null || newComponent["endpoint"] != "") ){
              valid = true
            }
          }
        } else {
          valid = true
        }
      }

      if(valid == true){
        // updateComponent = component
        this.formBuilderClose()
        this.componentsTableKey++
      } else {
        this.$message['error'](
          "Cannot save. Please validate your inputs."
        );
      }


    },
    deleteComponent(parameters){
      this.group = parameters.group
      this.component = parameters.component
      const dataSource = [...this.group.terminalSettings];
      this.group.terminalSettings = dataSource.filter(item => item.key !== this.component.key);
      this.refreshDataSet()
    },

    async saveDynamicForm(){
      console.log("HTTP Request")
      let response = {}
      if(this.mode == 'A'){
         response = await HTTPRequest.postRequest(
          '/api/v1/clp_account_custom_settings/',
          {
            account_dynamic_customer_fields: {
              dynamic_form: this.groups,
              custom_fields: this.dataSource
            }
          }
        );
      }else{
        response = await HTTPRequest.putRequest(
          '/api/v1/clp_account_custom_settings/' +  this.referenceId,
          {
            account_dynamic_customer_fields: {
              dynamic_form: this.groups,
              custom_fields: this.dataSource
            }
          }
        );
      }


      if (response.id) {
          this.formBuilderClose();
          this.$notification.success({
            message: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.currentStep = 0;
    }

    // --- END :: STEP 2 - Form Builder --- //
  },

  async mounted() {
    // Get values
    this.$store.dispatch('setCurrentModule', 'CustomizedSettings');
    this.selectedActions = this.$store.getters.getModuleSelectedActions;

    console.log("***")
    console.log(this.selectedActions)

    const response = await HTTPRequest.getRequest(
      '/api/v1/clp_account_custom_settings'
    );
    console.log(response)
    let existingFields = JSON.parse(response.custom_fields);
    if(existingFields != null){
      this.mode = 'U'
      this.referenceId = response.id
      this.groups = JSON.parse(response.dynamic_form);
      this.dataSource = existingFields;

    }else{
      this.mode = 'A'
    }
  }

};
</script>

<style scoped></style>
